module.exports = __webpack_public_path__ + "static/media/pin.d122df14.svg";